import * as Sentry from '@sentry/react'

const dsn = import.meta.env.VITE_SENTRY_DSN

// Sentry auto-enables only when a DSN is provided via env.
// Leave VITE_SENTRY_DSN unset to keep it disabled.
export const isSentryEnabled = Boolean(dsn) && import.meta.env.VITE_DEV !== 'true'

export const initSentry = () => {
  if (!isSentryEnabled) return

  return Sentry.init({
    dsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    integrations: [],
    release: `${import.meta.env.VITE_SENTRY_APP_NAME}@${import.meta.env.VITE_SENTRY_APP_VERSION}`,
    sendDefaultPii: false,
    tracesSampleRate: 0.2,
  })
}
